<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <!-- Custom Tabs Section -->
                    <div class="export-tabs">
                        <div 
                            :class="['export-tab-item', { active: activeTab === 'all' }]"
                            @click="selectTab('all')"
                        >
                            Tất cả
                        </div>
                        <div 
                            v-for="tab in tabList" 
                            :key="tab.value" 
                            :class="['export-tab-item', { active: activeTab === tab.value }]"
                            @click="selectTab(tab.value)"
                        >
                            {{ tab.name }}
                            <span v-if="getStateCount(tab.value) > 0" class="tab-count">{{ getStateCount(tab.value) }}</span>
                        </div>
                    </div>

                    <!-- Custom Filter Section -->
                    <div class="export-filter-section pt-4 pb-4 px-4">
                        <v-layout row wrap>
                            <!-- Tu ngay -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field outlined dense v-model="computedStartDateFormatted" label="Ngày xuất" append-icon="fa-calendar-alt" readonly v-on="on" hide-details></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filterForm.startDate" no-title @input="menuStart = false; applyFilters()"></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <!-- Den ngay -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field outlined dense v-model="computedEndDateFormatted" label="Ngày giao" append-icon="fa-calendar-alt" readonly v-on="on" hide-details></v-text-field>
                                    </template>
                                    <v-date-picker v-model="filterForm.endDate" no-title @input="menuEnd = false; applyFilters()"></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <!-- Ma phieu -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-text-field v-model="filterForm.id" label="Mã phiếu" outlined dense hide-details clearable @keyup.enter="applyFilters" @click:clear="applyFilters"></v-text-field>
                            </v-flex>

                            <!-- Khach hang -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-autocomplete v-model="filterForm.uid" :items="customers" item-text="Username" item-value="ID" label="Khách hàng" outlined dense hide-details clearable @change="applyFilters"></v-autocomplete>
                            </v-flex>

                            <!-- Ma khach hang -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-text-field v-model="filterForm.userCode" label="Mã khách hàng" outlined dense hide-details clearable @keyup.enter="applyFilters" @click:clear="applyFilters"></v-text-field>
                            </v-flex>

                            <!-- Nhan vien -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-autocomplete v-model="filterForm.createdBy" :items="staffOptions" item-text="name" item-value="value" label="Nhân viên" outlined dense hide-details clearable @change="applyFilters"></v-autocomplete>
                            </v-flex>

                            <!-- Kho xuat -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-autocomplete v-model="filterForm.receivePlaceId" :items="warehouseOptions" item-text="name" item-value="value" label="Kho xuất phiếu" outlined dense hide-details clearable @change="applyFilters"></v-autocomplete>
                            </v-flex>

                            <!-- Thu tien ship -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-autocomplete v-model="filterForm.shipPaymentType" :items="SHIP_PAYMENT_TYPES" item-text="name" item-value="value" label="Thu tiền Ship" outlined dense hide-details clearable @change="applyFilters"></v-autocomplete>
                            </v-flex>

                            <!-- Kieu ship hang -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1">
                                <v-autocomplete v-model="filterForm.shippingMethod" :items="SHIP_METHODS" item-text="name" item-value="name" label="Kiểu Ship hàng" outlined dense hide-details clearable @change="applyFilters"></v-autocomplete>
                            </v-flex>

                            <!-- Actions -->
                            <v-flex lg2 md3 sm6 class="px-2 py-1 d-flex align-center">
                                <v-btn color="success" class="mr-2" small @click="applyFilters">TÌM KIẾM</v-btn>
                                <v-btn color="warning" small @click="exportExcel">Xuất excel</v-btn>
                            </v-flex>
                        </v-layout>
                    </div>


                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item, index }">
                            <tr :id="'r-' + item.ID">
                                <td class="font-weight-bold">
                                    PXK{{ item.ID }}
                                </td>
                                <td class="caption text-no-wrap">
                                    {{ item.CreatedDate | display_date('DD-MM-YYYY HH:mm:ss') }}
                                    <br/><br/>
                                    {{ (item.DeliveryDate || item.ModifiedDate || item.CreatedDate) | display_date('DD-MM-YYYY HH:mm:ss') }}
                                </td>
                                <td>{{ getWarehouseName(item.UID) || 'Hà Nội' }}</td>
                                <td>{{ display_ship_method(item.ShippingMethod) }}</td>
                                <td>
                                    <span class="font-weight-bold blue--text">{{ getCustomerFullName(item.UID) }}</span>
                                    <br/>
                                    {{ item.UserCode }} - {{ item.Username }}
                                </td>
                                <td class="text-end">
                                    {{ item.Weight | currency('', 2) }}
                                    <br/>
                                    <strong>{{ (item.WeightCost || 0) | currency }}</strong>
                                </td>
                                <td class="text-end">
                                    {{ (item.ShipVN || 0) | currency }}
                                    <br/>
                                    <small>{{ display_ship_payment_type(item.ShipPaymentType) }}</small>
                                </td>
                                <td class="text-center">
                                    <input type="checkbox" v-model="item.IsFreeShip">
                                </td>
                                <td class="text-end">{{ (item.LiquidationAmount || 0) | currency }}</td>
                                <td class="text-end" v-bind:style="{ 'color': getCustomerWallet(item) < 0 ? 'red' : 'green' }">
                                    {{ getCustomerWallet(item) | currency }}
                                </td>
                                <td class="text-end" v-bind:style="{ 'color': getReceiptBalance(item) < 0 ? 'red' : 'green' }">
                                    {{ getReceiptBalance(item) | currency }}
                                </td>
                                <td>{{ item.CreatedByName || 'Kho NTG' }}</td>
                                <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                                <td v-bind:style="{ 'color': get_status_color(item.Status, receipt_status) }" class="font-weight-bold">
                                    {{ item.Status | display_value(receipt_status) }}
                                </td>
                                <td class="text-center">
                                    <v-btn small color="teal" class="white--text my-1" @click="gotoDetail(item)">Chi tiết</v-btn>
                                    <template v-if="canPayReceipt(item)">
                                        <br/>
                                        <v-btn
                                            small
                                            color="red darken-1"
                                            class="white--text my-1"
                                            :loading="payingReceiptId === item.ID"
                                            :disabled="payingReceiptId !== null"
                                            @click="paymentItem(item)"
                                        >Thanh toán</v-btn>
                                    </template>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr class="total-summary-td font-weight-bold">
                                <td colspan="5" class="text-center">Tổng</td>
                                <td class="text-end">{{ summary.Weight | currency('', 2) }}</td>
                                <td colspan="6"></td>
                                <td class="text-end">{{ summary.NumberOfPack | currency }}</td>
                                <td colspan="2"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogReceipt" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card v-if="dialogReceipt">
            <!-- Custom HTML detail & print view for existing receipts -->
            <div v-if="selectedItem.ID > 0">
              <ExportReceiptPrint
                :receipt="selectedItem"
                :packages="orderTransactions"
                :warehouses="warehouses"
                :customers="customers"
                :can-operate="canOperate"
                @close="dialogReceipt = false"
                @delete-package="deletePackageFromReceipt"
                @update-receipt="saveItem"
                @export="exportReceipt"
              />
            </div>
            
            <!-- Legacy Vuetify creation view for ID = 0 -->
            <template v-else>
              <v-toolbar dark color="oee-theme">
                  <v-btn icon dark @click="dialogReceipt = false">
                    <v-icon>fa-times-circle</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>Phiếu xuất kho #Tạo mới</v-toolbar-title>
              </v-toolbar>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1 white--text" class="mt-8 mr-2" @click="createNewReceipt">Tạo phiếu</v-btn>
              </v-card-actions>
              <v-card-text>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex lg12 md12 sm12>
                      <v-autocomplete
                        label="Khách hàng"
                        v-model="selectedItem.UID"
                        :items="approvedCustomers"
                        item-text="Username"
                        item-value="ID"
                        @change="onCustomerChange"
                        :rules="requireRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-text-field label="Tên người nhận" v-model="selectedItem.Receiver"></v-text-field>  
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-text-field label="Số điện thoại" v-model="selectedItem.Phone"></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-combobox
                        label="Hình thức ship"
                        v-model="selectedItem.ShippingMethod"
                        :items="SHIP_METHODS"
                        item-text="name"
                        item-value="name"
                        :return-object="false"
                      ></v-combobox>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-select
                        label="Thu tiền ship"
                        v-model="selectedItem.ShipPaymentType"
                        :items="SHIP_PAYMENT_TYPES"
                        item-text="name"
                        item-value="value"
                      ></v-select>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                      <v-text-field label="Địa chỉ nhận" v-model="selectedItem.Address"></v-text-field>
                    </v-flex>
      
                    <v-flex lg4 md4 sm12>
                      <v-text-field readonly label="Số kiện" type="number" v-model="selectedItem.NumberOfPack"></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <h-currency-input v-model="selectedItem.Weight" label="Tổng cân" :decimal="1" readonly></h-currency-input>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <h-currency-input v-model="selectedItem.Volume" label="Tổng khối" :decimal="2" readonly></h-currency-input>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                      <v-flex lg12 pt-0>
                          <v-card>
                              <v-data-table 
                                :headers="package_headers" 
                                :items="orderTransactions" 
                                :options.sync="package_pagination" 
                                :server-items-length="orderTransactions ? orderTransactions.length : 0" 
                                :must-sort="true" 
                                :mobile-breakpoint="100"
                                :show-select="true"
                                v-model="selectedPackages"
                                item-key="ID"
                              >
                                  <template v-slot:item="{ item, isSelected, select }">
                                      <tr :id="'r-' + item.ID">
                                          <td>
                                              <v-checkbox 
                                                primary 
                                                hide-details 
                                                :input-value="isSelected" 
                                                @change="select(!isSelected)"
                                              ></v-checkbox>
                                          </td>
                                          <td>{{ item.TransactionCode }}</td>
                                          <td><a target="_blank" :href="(item.PackageType == 1 ? '/ky-gui/' : '/don-hang/') + item.OrderID">{{ (item.PackageType == 1 ? 'KG' : 'MD') + item.OrderID }}</a></td>
                                          <td>{{ item.Weight | currency('', 2) }}</td>
                                          <td>{{ item.Volume | currency('', 2) }}</td>
                                          <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                                      </tr>
                                  </template>
                              </v-data-table>
                          </v-card>
                      </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </template>
          </v-card>
        </v-dialog>

        <v-dialog v-model="paymentConfirmDialog" persistent max-width="480">
            <v-card v-if="paymentConfirmItem" class="payment-confirm-card">
                <v-card-title class="payment-confirm-header white--text pa-5">
                    <v-avatar color="white" size="44" class="mr-3">
                        <v-icon color="red darken-1" size="22">fa-wallet</v-icon>
                    </v-avatar>
                    <div>
                        <div class="subtitle-1 font-weight-bold">Xác nhận thanh toán</div>
                        <div class="caption font-weight-regular">Thanh toán toàn bộ đơn hàng trên phiếu xuất</div>
                    </div>
                </v-card-title>

                <v-card-text class="pa-5">
                    <v-sheet outlined class="payment-confirm-summary mb-4">
                        <div class="payment-confirm-row">
                            <span>Mã phiếu</span>
                            <strong>PXK{{ paymentConfirmItem.ID }}</strong>
                        </div>
                        <div class="payment-confirm-row">
                            <span>Khách hàng</span>
                            <strong>{{ getCustomerFullName(paymentConfirmItem.UID) || paymentConfirmItem.Username }}</strong>
                        </div>
                        <div class="payment-confirm-row">
                            <span>Số dư ví hiện tại</span>
                            <strong>{{ getCustomerWallet(paymentConfirmItem) | currency }}</strong>
                        </div>
                        <div class="payment-confirm-row" v-if="paymentConfirmItem && (parseFloat(paymentConfirmItem.LiquidationAmount) || 0) > 0">
                            <span>Tiền hàng cần thanh toán</span>
                            <strong>{{ paymentConfirmItem.LiquidationAmount | currency }}</strong>
                        </div>
                        <div class="payment-confirm-row" v-if="paymentConfirmItem && getPayableShipVN(paymentConfirmItem) > 0">
                            <span>Tiền ship trừ ví</span>
                            <strong>{{ getPayableShipVN(paymentConfirmItem) | currency }}</strong>
                        </div>
                        <div class="payment-confirm-row payment-confirm-amount">
                            <span>Tổng tiền thanh toán</span>
                            <strong>{{ getTotalPayableAmount(paymentConfirmItem) | currency }}</strong>
                        </div>
                        <div class="payment-confirm-row">
                            <span>Số dư sau thanh toán</span>
                            <strong :class="hasSufficientWallet(paymentConfirmItem) ? 'success--text' : 'error--text'">
                                {{ getWalletAfterPayment(paymentConfirmItem) | currency }}
                            </strong>
                        </div>
                    </v-sheet>

                    <v-alert
                        dense
                        outlined
                        :type="hasSufficientWallet(paymentConfirmItem) ? 'warning' : 'error'"
                        class="mb-0"
                    >
                        <span v-if="hasSufficientWallet(paymentConfirmItem)">
                            Hệ thống sẽ trừ ví và thanh toán các khoản thuộc phiếu này. Thao tác không thể hoàn tác.
                        </span>
                        <span v-else>
                            Số dư ví khách hàng không đủ để thực hiện thanh toán.
                        </span>
                    </v-alert>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="payingReceiptId !== null" @click="closePaymentConfirm">Hủy</v-btn>
                    <v-btn
                        color="red darken-1"
                        class="white--text px-5"
                        :loading="payingReceiptId !== null"
                        :disabled="!hasSufficientWallet(paymentConfirmItem)"
                        @click="confirmPayment"
                    >
                        <v-icon size="14" class="mr-2">fa-check</v-icon>
                        Xác nhận thanh toán
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="vatConfirmDialog.show" persistent max-width="480">
            <v-card class="elevation-4" style="border-radius: 10px; overflow: hidden;">
                <v-card-title class="pa-4 d-flex align-center orange darken-2 white--text">
                    <v-avatar color="white" size="36" class="mr-3">
                        <v-icon color="orange darken-2" size="20">fa-exclamation-triangle</v-icon>
                    </v-avatar>
                    <div>
                        <div class="subtitle-1 font-weight-bold">Xác nhận thanh toán đơn NKCN</div>
                        <div class="caption white--text text--lighten-4">Chưa có thông tin thuế VAT</div>
                    </div>
                </v-card-title>
                <v-card-text class="pa-5 pt-4">
                    <v-alert dense outlined type="warning" class="mb-3">
                        {{ vatConfirmDialog.message }}
                    </v-alert>
                    <div style="font-size: 13px; color: #4B5563; line-height: 1.5;">
                        Đơn hàng loại NKCN chưa có thuế VAT (TaxVATAmount > 0). Bạn có chắc chắn muốn bỏ qua và tiếp tục thanh toán phiếu xuất không?
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="vatConfirmDialog.show = false" :disabled="vatConfirmLoading">Hủy</v-btn>
                    <v-btn
                        color="orange darken-2"
                        class="white--text px-4"
                        :loading="vatConfirmLoading"
                        @click="onVatConfirmOk"
                    >
                        <v-icon size="14" class="mr-2">fa-check</v-icon>
                        Đồng ý thanh toán
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import moment from "moment";
    import { sendErrorNotice, sendSuccessNotice, refreshResource, playSound } from '@/commons/utils';
    import { request_list, print_export_receipt_order } from '@/commons/hpod';
    import Vue from 'vue';
    import _ from "lodash";
    
    import ExportReceiptPrint from "./ExportReceiptPrint.vue";
    import { calculateLiquidationAmount } from "./liquidation";
    
    const SHIP_METHODS = configs.SHIP_METHODS || [];

    const SHIP_PAYMENT_TYPES = [
        { value: 1, name: 'Free ship' },
        { value: 0, name: 'Trừ ví điện tử của khách' },
        { value: 2, name: 'Kho ship thu tiền mặt từ khách' },
        { value: 3, name: 'Shipper tự thu' }
    ];

    const EXPORT_RECEIPT_STATUS = {
        PREPARING: 'chuan_bi',
        WAITING_REDELIVERY: 'cho_giao_lai',
        SHIPPING: 'dang_giao',
        EXPORTED: 'da_xuat',
        CANCELED: 'da_huy'
    };

    const UNPAID_TAB = 'chua_thanh_toan';
    
    export default {
        components: {
            ExportReceiptPrint
        },
        data() {
            return {
                SHIP_METHODS: SHIP_METHODS,
                SHIP_PAYMENT_TYPES: SHIP_PAYMENT_TYPES,
                activeTab: 'all',
                menuStart: false,
                menuEnd: false,
                tabCounts: {
                    chuan_bi: 0,
                    cho_giao_lai: 0,
                    dang_giao: 0,
                    da_xuat: 0,
                    chua_thanh_toan: 0,
                    da_huy: 0
                },
                filterForm: {
                    startDate: null,
                    endDate: null,
                    id: '',
                    uid: null,
                    userCode: '',
                    createdBy: null,
                    receivePlaceId: null,
                    shipPaymentType: null,
                    shippingMethod: null
                },
                headers: [
                    {
                        text: "Mã phiếu",
                        value: "ID",
                        filterable: true,
                        quickSearch: true,
                        width: '100px',
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ngày xuất / Ngày giao",
                        value: "CreatedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Kho xuất",
                        value: "ReceivePlaceID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: []
                    },
                    {
                        text: "Kiểu ship",
                        value: "ShippingMethod",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: SHIP_METHODS.map(x => ({ value: x.name, name: x.name }))
                    },
                    {
                        text: "Khách hàng",
                        value: "UserCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tổng cân / Tiền cân nặng",
                        value: "Weight",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ship VN / Kiểu thu tiền",
                        value: "ShipVN",
                        align: "end",
                        sortable: false,
                        filterable: false
                    },
                    {
                        text: "Free ship",
                        value: "IsFreeShip",
                        align: "center",
                        sortable: false,
                        filterable: false
                    },
                    {
                        text: "Tiền thanh lý",
                        value: "LiquidationAmount",
                        align: "end",
                        sortable: false,
                        filterable: false
                    },
                    {
                        text: "Số dư khách hiện tại",
                        value: "Wallet",
                        align: "end",
                        sortable: false,
                        filterable: false
                    },
                    {
                        text: "Số dư khách sau khi xuất kho",
                        value: "WalletAfterExport",
                        align: "end",
                        sortable: false,
                        filterable: false
                    },
                    {
                        text: "Nhân viên xuất",
                        value: "CreatedBy",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: []
                    },
                    {
                        text: "Số kiện",
                        value: "NumberOfPack",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        values: configs.EXPORT_RECEIPT_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Thao tác",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                package_headers: [
                    {
                        text: "Mã bill",
                        value: "TransactionCode",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã đơn hàng",
                        value: "OrderID",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cân nặng",
                        value: "Weight",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Khối",
                        value: "Volume",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        values: configs.PACKAGE_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    }
                ],
                dialogReceipt: false,
                useInternalCode: false,
                chkCheckBill: false,
                totalMatched: 0,
                package_status: configs.PACKAGE_STATUS,
                receipt_status: configs.EXPORT_RECEIPT_STATUS,
                order_type_list: configs.ORDER_TYPE_LIST,
                pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
                package_pagination: {  ...configs.PAGINATION,  sortBy: ["ID"], itemsPerPage: -1 },
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                viewName: "exportreceipt_list",
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                selectedItem: {},
                selectedPackages: [],
                payingReceiptId: null,
                paymentConfirmDialog: false,
                paymentConfirmItem: null,
                vatConfirmDialog: {
                    show: false,
                    message: '',
                    receiptId: null
                },
                vatConfirmLoading: false,
                newTransactionCode: '',
                newTransactionCodeVN: '',
                internalMessage: '',
                isDepositOrder: configs.SYSTEM_TYPE != 'order',
                bigpackageCode: ''
            };
        },
        watch: {
            '$route.query.id': {
                handler: function (receiptId) {
                    if (receiptId) {
                        this.$store.dispatch("exportReceipt/getDetail", receiptId).then(item => {
                            if (item) {
                                this.gotoDetail(item);
                                const query = { ...this.$route.query };
                                delete query.id;
                                this.$router.replace({ query }).catch(() => {});
                            }
                        });
                    }
                },
                immediate: true
            },
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            items() {
                if(this.dialogReceipt && this.selectedItem.ID) {
                   let item = _.find(this.items, {'ID': this.selectedItem.ID});
                   if (item) {
                       this.selectedItem = item;
                   }
                }
            },
            dialogReceipt() {
                if(!this.dialogReceipt){
                    this.selectedItem = {};
                    this.totalMatched = 0;
                    this.chkCheckBill = false;
                }
            },
            selectedPackages: {
                handler: function (val) {
                    if (this.selectedItem.ID == 0) {
                        this.selectedItem.NumberOfPack = _.sumBy(val, p => parseInt(p.NumberOfPack) || 1);
                        this.selectedItem.Weight = _.sumBy(val, p => parseFloat(p.Weight) || 0);
                        this.selectedItem.Volume = _.sumBy(val, p => parseFloat(p.Volume) || 0);
                    }
                },
                deep: true
            },
            staffOptions(newVal) {
                const header = _.find(this.headers, { value: 'CreatedBy' });
                if (header) {
                    header.values = newVal;
                }
            },
            warehouseOptions(newVal) {
                const header = _.find(this.headers, { value: 'ReceivePlaceID' });
                if (header) {
                    header.values = newVal;
                }
            }
        },
        computed: {
            ...mapState({
                items: state => state.exportReceipt.all.data,
                total_rows: state => state.exportReceipt.all.total,
                loading: state => state.exportReceipt.loading,
                orderTransactions: state => state.orderTransaction.all.data,
                configuration: state => state.configuration.selected,
                customers: state => state.customer.master.data,
                warehouses: state => state.warehouse.all.data,
                staffs: state => state.commons.all_users
            }),
            approvedCustomers() {
                return _.filter(this.customers, { FinanceApproved: 1 });
            },
            adminRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            },
            canOperate() {
                const roleType = Number(this.$store.state.authentication.user.roletype) || 0;
                const isAdmin = (roleType & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin;
                const isPayment = (roleType & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
                const isManager = (roleType & configs.ROLE_TYPE.Manager) === configs.ROLE_TYPE.Manager;
                const isStoreVN = (roleType & configs.ROLE_TYPE.StoreVN) === configs.ROLE_TYPE.StoreVN;
                return isAdmin || isManager || isPayment || isStoreVN;
            },
            canProcessPayment() {
                const roleType = Number(this.$store.state.authentication.user.roletype) || 0;
                return roleType > 0 && (
                    (roleType & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin
                    || (roleType & configs.ROLE_TYPE.Payment) === configs.ROLE_TYPE.Payment
                );
            },
            tableConfig() {
                return {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                }
            },
            staffOptions() {
                return _.map(this.staffs, s => ({
                    value: s.ID,
                    name: s.FullName || s.fullname || s.Username
                })) || [];
            },
            warehouseOptions() {
                return _.map(this.warehouses, w => ({
                    value: w.ID,
                    name: w.Name
                })) || [];
            },
            listStatus() {
                return configs.EXPORT_RECEIPT_STATUS;
            },
            orderSummary() {
                const items = this.items || [];
                const total0 = _.filter(items, { Status: EXPORT_RECEIPT_STATUS.PREPARING }).length;
                const total1 = _.filter(items, { Status: EXPORT_RECEIPT_STATUS.EXPORTED }).length;
                return {
                    TotalStatus0: total0,
                    TotalStatus1: total1,
                    TotalStatusAll: this.total_rows || 0
                };
            },
            summary() {
                if (!this.items || this.items.length === 0) return null;
                return {
                    NumberOfPack: _.sumBy(this.items, p => parseInt(p.NumberOfPack) || 0),
                    Weight: _.sumBy(this.items, p => parseFloat(p.Weight) || 0),
                    Volume: _.sumBy(this.items, p => parseFloat(p.Volume) || 0)
                };
            },
            tabList() {
                const tabs = _.cloneDeep(configs.EXPORT_RECEIPT_STATUS || []);
                const exportedIndex = _.findIndex(tabs, { value: EXPORT_RECEIPT_STATUS.EXPORTED });
                const unpaidTabIndex = exportedIndex >= 0 ? exportedIndex + 1 : tabs.length;
                tabs.splice(unpaidTabIndex, 0, {
                    value: UNPAID_TAB,
                    name: 'Chưa thanh toán',
                    color: '#d32f2f'
                });
                return tabs;
            },
            computedStartDateFormatted() {
                return this.filterForm.startDate ? moment(this.filterForm.startDate).format(configs.SHORT_DATE_FORMAT) : '';
            },
            computedEndDateFormatted() {
                return this.filterForm.endDate ? moment(this.filterForm.endDate).format(configs.SHORT_DATE_FORMAT) : '';
            }
        },
        methods: {
            filter_data: function () {
                this.$store.dispatch("exportReceipt/getList", this.tableConfig);
                this.fetchTabCounts();
                if(this.dialogReceipt) {
                    this.getTransactionOfReceipt();
                }
            },
            applyFilters() {
                const filters = this.buildFilters(true);
                let storeFilters = this.$store.state.commons.filterConditions || {};
                storeFilters[this.viewName] = filters;
                this.$store.commit("commons/setFilterConditions", {
                    filter: storeFilters
                });

                let sortBy = this.pagination.sortBy;
                let sortDesc = this.pagination.sortDesc;
                this.pagination = { ...configs.PAGINATION };
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filter_data();
            },
            resetFilters() {
                this.activeTab = 'all';
                this.filterForm = {
                    startDate: null,
                    endDate: null,
                    id: '',
                    uid: null,
                    userCode: '',
                    createdBy: null,
                    receivePlaceId: null,
                    shipPaymentType: null,
                    shippingMethod: null
                };
                this.applyFilters();
            },
            selectTab(tabVal) {
                this.activeTab = tabVal;
                this.applyFilters();
            },
            getStateCount(tabVal) {
                return (this.tabCounts && this.tabCounts[tabVal]) || 0;
            },
            buildFilters(includeState = true) {
                const filters = [];
                if (includeState && this.activeTab !== 'all') {
                    filters.push(...this.getTabFilters(this.activeTab));
                }
                if (this.filterForm.startDate) {
                    filters.push({
                        column: 'CreatedDate',
                        value: moment(this.filterForm.startDate).format('YYYY-MM-DD'),
                        condition: 'd_greater_than_or_equal'
                    });
                }
                if (this.filterForm.endDate) {
                    filters.push({
                        column: 'CreatedDate',
                        value: moment(this.filterForm.endDate).format('YYYY-MM-DD'),
                        condition: 'd_less_than_or_equal'
                    });
                }
                if (this.filterForm.id) {
                    const idVal = this.filterForm.id.trim();
                    if (idVal) {
                        filters.push({
                            column: 'ID',
                            value: parseInt(idVal) || idVal,
                            condition: 'equal'
                        });
                    }
                }
                if (this.filterForm.uid !== null && this.filterForm.uid !== undefined) {
                    filters.push({
                        column: 'UID',
                        value: this.filterForm.uid,
                        condition: 'equal'
                    });
                }
                if (this.filterForm.userCode) {
                    const codeVal = this.filterForm.userCode.trim();
                    if (codeVal) {
                        filters.push({
                            column: 'UserCode',
                            value: codeVal,
                            condition: 'contain'
                        });
                    }
                }
                if (this.filterForm.createdBy !== null && this.filterForm.createdBy !== undefined) {
                    filters.push({
                        column: 'CreatedBy',
                        value: this.filterForm.createdBy,
                        condition: 'equal'
                    });
                }
                if (this.filterForm.receivePlaceId !== null && this.filterForm.receivePlaceId !== undefined) {
                    filters.push({
                        column: 'ReceivePlaceID',
                        value: this.filterForm.receivePlaceId,
                        condition: 'equal'
                    });
                }
                if (this.filterForm.shipPaymentType !== null && this.filterForm.shipPaymentType !== undefined) {
                    filters.push({
                        column: 'ShipPaymentType',
                        value: this.filterForm.shipPaymentType,
                        condition: 'equal'
                    });
                }
                if (this.filterForm.shippingMethod !== null && this.filterForm.shippingMethod !== undefined) {
                    filters.push({
                        column: 'ShippingMethod',
                        value: this.filterForm.shippingMethod,
                        condition: 's_equal'
                    });
                }
                return filters;
            },
            getTabFilters(tabValue) {
                if (tabValue === UNPAID_TAB) {
                    return [
                        { column: 'Status', value: EXPORT_RECEIPT_STATUS.EXPORTED, condition: 's_equal' },
                        { column: 'LiquidationAmount', value: 0, condition: 'greater_than' }
                    ];
                }
                return [{ column: 'Status', value: tabValue, condition: 's_equal' }];
            },
            fetchTabCounts() {
                if (!this.tabCounts) {
                    this.tabCounts = {};
                }
                const token = this.$store.state.authentication.token;
                const activeFiltersExceptState = this.buildFilters(false);
                this.tabList.forEach(tab => {
                    const param = {
                        filter: [
                            ...activeFiltersExceptState,
                            ...this.getTabFilters(tab.value)
                        ],
                        pagination: { page: 1, itemsPerPage: 1 }
                    };
                    request_list('export-receipt', (res) => {
                        this.$set(this.tabCounts, tab.value, res.total || 0);
                    }, this.$http, param, token);
                });
            },
            initFiltersFromStore() {
                const storeFilters = this.$store.state.commons.filterConditions || {};
                const filters = storeFilters[this.viewName] || [];
                
                this.activeTab = 'all';
                this.filterForm = {
                    startDate: null,
                    endDate: null,
                    id: '',
                    uid: null,
                    userCode: '',
                    createdBy: null,
                    receivePlaceId: null,
                    shipPaymentType: null,
                    shippingMethod: null
                };

                const isUnpaidFilter = filters.some(f => (
                    f.column === 'Status'
                    && f.condition === 's_equal'
                    && f.value === EXPORT_RECEIPT_STATUS.EXPORTED
                )) && filters.some(f => (
                    f.column === 'LiquidationAmount'
                    && f.condition === 'greater_than'
                    && Number(f.value) === 0
                ));
                if (isUnpaidFilter) {
                    this.activeTab = UNPAID_TAB;
                }
                
                filters.forEach(f => {
                    if (f.column === 'Status' && !isUnpaidFilter) {
                        this.activeTab = f.value;
                    } else if (f.column === 'CreatedDate' && f.condition === 'd_greater_than_or_equal') {
                        this.filterForm.startDate = f.value;
                    } else if (f.column === 'CreatedDate' && f.condition === 'd_less_than_or_equal') {
                        this.filterForm.endDate = f.value;
                    } else if (f.column === 'ID') {
                        this.filterForm.id = f.value.toString();
                    } else if (f.column === 'UID') {
                        this.filterForm.uid = f.value;
                    } else if (f.column === 'UserCode') {
                        this.filterForm.userCode = f.value;
                    } else if (f.column === 'CreatedBy') {
                        this.filterForm.createdBy = f.value;
                    } else if (f.column === 'ReceivePlaceID') {
                        this.filterForm.receivePlaceId = f.value;
                    } else if (f.column === 'ShipPaymentType') {
                        this.filterForm.shipPaymentType = f.value;
                    } else if (f.column === 'ShippingMethod') {
                        this.filterForm.shippingMethod = f.value;
                    }
                });
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            get_status_color(val, enums) {
                return this.$options.filters.display_color(val, enums);
            },
            getTransactionOfReceipt() {
                if(this.selectedItem.ID > 0) {
                    var param={
                        filter: [
                        {
                            column: "ReceiptID",
                            value: this.selectedItem.ID,
                            condition: "equal"
                        }
                        ]
                    };
                    this.$store.dispatch("orderTransaction/getList", param);
                }            
            },
            createData() {
                if(!this.adminRole) {
                    sendErrorNotice("Bạn không có quyền tạo phiếu xuất kho");
                    return;
                }
                this.selectedItem = {
                    ID: 0,
                    UID: 0,
                    Status: EXPORT_RECEIPT_STATUS.PREPARING,
                    Receiver: '',
                    Phone: '',
                    ShippingMethod: '',
                    Address: '',
                    ShipPaymentType: 0
                };
                this.selectedPackages = [];
                this.$store.commit("orderTransaction/setList", {data: [], total: 0});
                this.dialogReceipt = true;
            },
            gotoDetail(item) {
                this.selectedItem = item;
                this.getTransactionOfReceipt();
                this.dialogReceipt = true;
            },
            printDetail() {
                const frame_printing = print_export_receipt_order({...this.selectedItem, Voter: this.$store.state.authentication.user.fullname}, this.orderTransactions, true);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            },
            printItem(item) {
                const param = {
                    filter: [
                        {
                            column: "ReceiptID",
                            value: item.ID,
                            condition: "equal"
                        }
                    ]
                };
                request_list('order_transactions', (data) => {
                    const frame_printing = print_export_receipt_order({...item, Voter: this.$store.state.authentication.user.fullname}, data.data, true);
                    var doc = document.getElementById('print_frame').contentWindow.document;
                    doc.open();
                    doc.write(frame_printing);
                    doc.close();
                    setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
                }, this.$http, param, this.$store.state.authentication.token);
            },
            deleteItem(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            saveItem(item) {
                this.$store.dispatch("exportReceipt/setDetail", {
                    data: item,
                    id: item.ID
                });
            },
            deletePackageFromReceipt(packageId) {
                if (this.selectedItem.ID === 0) {
                    this.selectedPackages = this.selectedPackages.filter(p => p.ID !== packageId);
                } else {
                    const currentList = this.$store.state.orderTransaction.all.data || [];
                    const updatedList = currentList.filter(p => p.ID !== packageId);
                    this.$store.commit("orderTransaction/setList", {
                        ...this.$store.state.orderTransaction.all,
                        data: updatedList,
                        total: updatedList.length
                    });
                    
                    this.$store.dispatch("orderTransaction/setDetail", {
                        data: {
                            ID: packageId,
                            ReceiptID: '[null]',
                            Status: 4
                        },
                        id: packageId
                    });
                }
            },
            async exportReceipt(payload) {
                // If it's a number (ID), wrap it in object, otherwise use the payload
                const updateData = typeof payload === 'number' || typeof payload === 'string' 
                    ? { ID: payload }
                    : payload;

                const transactionIds = _.map(this.orderTransactions || [], 'ID').filter(Boolean);
                if (transactionIds.length > 0) {
                    await this.$store.dispatch("orderTransaction/updateMultiple", {
                        TransactionIDs: transactionIds,
                        Status: configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN
                    });
                }

                this.saveItem({
                    ...updateData,
                    Status: EXPORT_RECEIPT_STATUS.EXPORTED
                });
                this.dialogReceipt = false;
            },
            getCustomerList() {
                this.$store.dispatch("customer/getCustomerList", {
                    is_master: 1,
                    fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID", "PhonePrefix", "PhoneNumber", "Address", "FinanceApproved", "Wallet", "FirstName", "LastName"]
                });
            },
            onCustomerChange(uid) {
                const customer = _.find(this.customers, { ID: uid });
                if (customer) {
                    this.selectedItem.Username = customer.Username;
                    this.selectedItem.Receiver = customer.Username;
                    this.selectedItem.Phone = (customer.PhonePrefix || '') + (customer.PhoneNumber || '');
                    this.selectedItem.Address = customer.Address || '';
                    this.selectedPackages = [];
                    this.loadAvailablePackages(uid);
                }
            },
            loadAvailablePackages(uid) {
                const param = {
                    filter: [
                        { column: "UID", value: uid, condition: "equal" },
                        { column: "Status", value: 4, condition: "equal" },
                        { column: "ReceiptID", condition: "is_null" }
                    ],
                    pagination: { itemsPerPage: -1, sortBy: ["ID"], sortDesc: [false] }
                };
                this.$store.dispatch("orderTransaction/getList", param);
            },
            createNewReceipt() {
                if (!this.selectedItem.UID) {
                    sendErrorNotice("Hãy chọn khách hàng!");
                    return;
                }
                if (!this.selectedPackages || this.selectedPackages.length === 0) {
                    sendErrorNotice("Hãy chọn ít nhất một kiện hàng để tạo phiếu!");
                    return;
                }
                const customer = _.find(this.customers, { ID: this.selectedItem.UID });
                if (!customer || customer.FinanceApproved === 0) {
                    sendErrorNotice("Khách hàng chưa được duyệt tài chính. Không thể tạo phiếu xuất.");
                    return;
                }
                const item = {
                    UID: this.selectedItem.UID,
                    Username: this.selectedItem.Username,
                    Receiver: this.selectedItem.Receiver,
                    Phone: this.selectedItem.Phone,
                    ShippingMethod: this.selectedItem.ShippingMethod,
                    ShipPaymentType: this.selectedItem.ShipPaymentType !== undefined && this.selectedItem.ShipPaymentType !== null ? this.selectedItem.ShipPaymentType : 0,
                    Address: this.selectedItem.Address,
                    LiquidationAmount: calculateLiquidationAmount(this.selectedPackages),
                    Status: EXPORT_RECEIPT_STATUS.PREPARING,
                    package_ids: this.selectedPackages.map(p => p.ID)
                };
                this.$store.dispatch("exportReceipt/setDetail", {
                    data: item,
                    id: 0
                });
                this.dialogReceipt = false;
                this.selectedPackages = [];
            },
            getWarehouseName(uid) {
                const customer = _.find(this.customers, { ID: uid });
                if (customer && customer.ReceivePlaceID) {
                    const wh = _.find(this.warehouses, { ID: customer.ReceivePlaceID });
                    return wh ? wh.Name : '';
                }
                return '';
            },
            getCustomerFullName(uid) {
                const customer = _.find(this.customers, { ID: uid });
                if (customer) {
                    const firstName = customer.FirstName || '';
                    const lastName = customer.LastName || '';
                    return (lastName + ' ' + firstName).trim() || customer.Username;
                }
                return '';
            },
            getPayableShipVN(item) {
                if (!item) return 0;
                if (item.IsPaidShip == 1) return 0;
                const paymentType = Number(item.ShipPaymentType !== undefined && item.ShipPaymentType !== null ? item.ShipPaymentType : 0);
                return paymentType === 0 ? (parseFloat(item.ShipVN) || 0) : 0;
            },
            getTotalPayableAmount(item) {
                if (!item) return 0;
                const liquidationAmount = parseFloat(item.LiquidationAmount) || 0;
                const shipVN = this.getPayableShipVN(item);
                return liquidationAmount + shipVN;
            },
            getReceiptBalance(item) {
                if (!item) return 0;
                return this.getCustomerWallet(item)
                    - (parseFloat(item.LiquidationAmount) || 0)
                    - this.getPayableShipVN(item);
            },
            canPayReceipt(item) {
                return this.canProcessPayment
                    && this.getTotalPayableAmount(item) > 0;
            },
            paymentItem(item) {
                if (!this.canPayReceipt(item) || this.payingReceiptId !== null) {
                    return;
                }
                this.paymentConfirmItem = item;
                this.paymentConfirmDialog = true;
            },
            getWalletAfterPayment(item) {
                return this.getCustomerWallet(item) - this.getTotalPayableAmount(item);
            },
            hasSufficientWallet(item) {
                return this.getWalletAfterPayment(item) >= 0;
            },
            closePaymentConfirm() {
                if (this.payingReceiptId !== null) {
                    return;
                }
                this.paymentConfirmDialog = false;
                this.paymentConfirmItem = null;
            },
            async confirmPayment(ignoreVatCheck = false) {
                if (typeof ignoreVatCheck !== 'boolean') {
                    ignoreVatCheck = false;
                }
                const item = this.paymentConfirmItem;
                if (!item || !this.canPayReceipt(item) || !this.hasSufficientWallet(item) || this.payingReceiptId !== null) {
                    return;
                }
                this.payingReceiptId = item.ID;
                try {
                    await this.$store.dispatch('exportReceipt/payReceipt', {
                        receiptId: item.ID,
                        ignore_vat_check: ignoreVatCheck
                    });
                    this.paymentConfirmDialog = false;
                    this.paymentConfirmItem = null;
                    this.getCustomerList();
                    this.filter_data();
                } catch (error) {
                    const isVatError = error && (
                        error.need_confirm_vat ||
                        (error.reason && error.reason.includes('chưa có thông tin thuế VAT')) ||
                        (error.message && error.message.includes('chưa có thông tin thuế VAT'))
                    );
                    if (isVatError && !ignoreVatCheck) {
                        const reasonMsg = error.reason || error.message || 'Đơn hàng (loại NKCN) chưa có thông tin thuế VAT (TaxVATAmount > 0).';
                        this.vatConfirmDialog = {
                            show: true,
                            message: reasonMsg.replace('Không thể thanh toán.', '').trim(),
                            receiptId: item.ID
                        };
                    }
                } finally {
                    this.payingReceiptId = null;
                }
            },
            async onVatConfirmOk() {
                this.vatConfirmLoading = true;
                try {
                    await this.$store.dispatch('exportReceipt/payReceipt', {
                        receiptId: this.vatConfirmDialog.receiptId,
                        ignore_vat_check: true
                    });
                    this.vatConfirmDialog.show = false;
                    this.paymentConfirmDialog = false;
                    this.paymentConfirmItem = null;
                    this.getCustomerList();
                    this.filter_data();
                } catch (error) {
                    // Error is notified by the store action
                } finally {
                    this.vatConfirmLoading = false;
                }
            },
            display_ship_method(val) {
                if (val === null || val === undefined || val === '') return '';
                const method = _.find(SHIP_METHODS, item => item.name.toLowerCase() === val.toString().toLowerCase() || item.value.toString() === val.toString());
                return method ? method.name : val;
            },
            display_ship_payment_type(val) {
                const payment = _.find(SHIP_PAYMENT_TYPES, p => p.value.toString() === (val !== undefined && val !== null ? val.toString() : '0'));
                return payment ? payment.name : 'Trừ ví điện tử của khách';
            },
            getCustomerWallet(customerOrReceipt) {
                if (customerOrReceipt && typeof customerOrReceipt === 'object') {
                    return parseFloat(customerOrReceipt.Wallet) || 0;
                }
                const customer = _.find(this.customers, { ID: customerOrReceipt });
                return customer ? (parseFloat(customer.Wallet) || 0) : 0;
            },
            exportExcel() {
                this.$store.dispatch("exportReceipt/export_excel", this.tableConfig);
            }
        },
        mounted() {
            this.initFiltersFromStore();
            this.$store.dispatch("configuration/getDetail", 1);
            this.getCustomerList();
            this.$store.dispatch("commons/getAllUsers");
            this.$store.dispatch("warehouse/getList", { pagination: { itemsPerPage: -1 } });
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.createData);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.createData);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        }
    };
</script>
<style scoped>
    .bill-checked {
        background-color: rgb(1, 187, 125);
    }

    /* Custom Tabs Section */
    .export-tabs {
        display: flex;
        background: #fff;
        border-bottom: 1px solid #ddd;
        padding: 0 10px;
    }
    .export-tab-item {
        padding: 12px 20px;
        cursor: pointer;
        color: #777;
        font-weight: bold;
        position: relative;
        border: 1px solid transparent;
        transition: all 0.3s ease;
    }
    .export-tab-item:hover {
        color: #333;
    }
    .export-tab-item.active {
        color: #00a65a;
        background: #fff;
        border: 1px solid #ddd;
        border-bottom-color: transparent;
        margin-bottom: -1px;
        border-radius: 4px 4px 0 0;
    }
    .export-tab-item .tab-count {
        font-size: 10px;
        vertical-align: top;
        color: red;
        margin-left: 3px;
        font-weight: bold;
    }

    /* Custom Filter Section */
    .export-filter-section {
        background: #fff;
        border-bottom: 1px solid #ddd;
    }

    .payment-confirm-card {
        overflow: hidden;
        border-radius: 10px;
    }

    .payment-confirm-header {
        background: linear-gradient(135deg, #c62828, #ef5350);
    }

    .payment-confirm-summary {
        overflow: hidden;
        border-radius: 8px;
    }

    .payment-confirm-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 11px 14px;
        border-bottom: 1px solid #eee;
        color: #555;
    }

    .payment-confirm-row:last-child {
        border-bottom: 0;
    }

    .payment-confirm-row strong {
        color: #222;
        text-align: right;
    }

    .payment-confirm-amount {
        background: #fff5f5;
    }

    .payment-confirm-amount strong {
        color: #d32f2f;
        font-size: 20px;
    }
</style>
